@if (confirmationMessage.title) {
  <div class="modal-header">
    <h1 class="page-title">{{ confirmationMessage.title }}</h1>
  </div>
}
<div class="modal-body mt-0">
  <p>
    @if (name) {
      {{ confirmationMessage.message }} {{ actionType ? actionType + ' ' : ''
      }}{{ name | capitalizeFirst }}
    } @else {
      {{ confirmationMessage.message }}
    }
  </p>
</div>
<div class="modal-footer p-0">
  <button type="button" class="btn unfill border btn-md-popup m-0" (click)="onNegativeClick()">
    {{ confirmationMessage.negativeBtn }}
  </button>

  <button
    type="button"
    class="btn btn-primary btn-md-popup me-0 my-0 ms-2"
    (click)="onPositiveClick()"
  >
    {{ confirmationMessage.positiveBtn }}
  </button>
</div>
